import { Currency } from 'enums/currency';
import { cookieService } from 'services/CookieService';
import create from 'zustand';
import { devtools } from 'zustand/middleware';

interface CurrencyState {
  currency: Currency;
  setCurrency: (val: CurrencyState['currency']) => void;
}

export const useCurrencyState = create<CurrencyState>()(
  devtools((set) => {
    return {
      currency:
        (cookieService.getCookie('currency', {}) as Currency) || Currency.TRY,
      setCurrency: (val) =>
        set((state) => {
          cookieService.setCookie('currency', val, {});
          return { ...state, currency: val };
        }),
    };
  })
);
